import { Alert, Button, FormField, Input, Stack, Text } from '@ui';
import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { errorMessage } from '../../../lib/errors';
import { useRequestPasswordReset } from '../api';
import { PublicPage } from '../components/PublicPage';

/** Requests a link to set a new password (AUTH-004). */
export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const request = useRequestPasswordReset();
  const [email, setEmail] = useState('');

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    request.mutate(email);
  };

  return (
    <PublicPage
      title={t('auth.forgot.title')}
      description={request.isSuccess ? undefined : t('auth.forgot.description')}
    >
      {request.isSuccess ? (
        <Alert tone="success">{t('auth.forgot.sent')}</Alert>
      ) : (
        <Stack as="form" gap={4} onSubmit={onSubmit} noValidate>
          {request.error && <Alert tone="danger">{errorMessage(request.error)}</Alert>}
          <FormField label={t('auth.email')} required>
            {(p) => (
              <Input
                {...p}
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            )}
          </FormField>
          <Button type="submit" size="lg" fullWidth loading={request.isPending}>
            {t('auth.forgot.submit')}
          </Button>
        </Stack>
      )}
      <Text size="sm">
        <Link to="/anmelden">{t('auth.forgot.backToLogin')}</Link>
      </Text>
    </PublicPage>
  );
}
